import EmptyTitle from './EmptyTitle.vue';

export default EmptyTitle;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/components/result/components/emptytitle/index.ts